import crypto from 'node:crypto';
import path from 'node:path';
import os from 'node:os';

const QUEUE_KEY_HEX_64 = /^[a-f0-9]{64}$/i;

/**
 * Stable filename segment for a queue key: 64-char hex keys use as-is (lowercased);
 * other keys (e.g. legacy work-queue strings) use SHA-256 hex so paths stay safe and unique.
 * (Still used for tests and stable naming; queue state lives in CLI SQLite.)
 */
export function queueStateFileSlug(queueKey: string): string {
  if (QUEUE_KEY_HEX_64.test(queueKey)) return queueKey.toLowerCase();
  return crypto.createHash('sha256').update(queueKey, 'utf8').digest('hex');
}

/** `~/.buildautomaton/queues` — legacy JSON location (migration reads from here once). */
export function getPromptQueuesDirectory(): string {
  const override = process.env.BUILDAMATON_PROMPT_QUEUES_DIR?.trim();
  if (override) return path.resolve(override);
  return path.join(os.homedir(), '.buildautomaton', 'queues');
}
